module.exports = __webpack_public_path__ + "static/media/PH3800__004_Strange-30sec.9a5c2e6d.mp3";